import { useQuery } from '@tanstack/react-query';

import departureService from '~/services/cruises/DepartureService';

import { departureQueryKeys } from './departureQueryKeys';

export function useGetDepartureDataFeed(departureId: string, cruiseType: string, date?: string) {
  return useQuery({
    queryKey: departureQueryKeys.dataFeed(departureId, cruiseType, date),
    queryFn: async ({ signal }) => {
      const response = await departureService.getDataFeedByDepartureId(departureId, cruiseType, date, { signal });

      if (!response?.result) {
        throw new Error('No data feed found');
      }

      return response?.result;
    },
    enabled: !!departureId && !!cruiseType,
    retry: false,
  });
}
